
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Workorder,
  WorkordersApi,
  ValidationProblemDetails,
  ValueListItem,
  SystemApi,
  ReassignKind,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';
import ScrollIntoView from '@/services/ScrollIntoView';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    ordersApi: 'ordersApi',
    systemApi: 'systemApi',
    settings: 'settings'
  })
})
export default class ReassignOrderComponent extends Vue {
  private currentUser!: User;
  private reasons!: ValueListItem[];
  private settings!: PerformoSettings;

  private ordersApi!: WorkordersApi;
  private systemApi!: SystemApi;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  reason = '';
  newAssignee = '';

  tab = 0;

  private popoverOpen = false;
  private validationProblems: ValidationProblemDetails = {};

  get canReassign() {
    let canReassign = false;
    this.currentUser.profile.candoq.forEach((candoq: string) => {
      if (candoq.startsWith('Reassign Orders:') && !candoq.endsWith(' None')) {
        canReassign = true;
      }
    });
    return canReassign;
  }

  data() {
    return {
      reasons: []
    };
  }

  async mounted() {
    this.reasons = await this.systemApi.getValueListItems({
      // use ALL for reassign reason entity query #1118.
      // Reassign Reasons are system wide, not entity specific.
      propertyId: 'ALL',
      name: 'Reassign Reasons'
    });
  }

  private successHandler(order: Workorder) {
    if (order && order.workorderId) {
      this.$emit('reassigned');
      this.popoverOpen = false;
      this.newAssignee = '';
      this.reason = '';
      this.validationProblems = {};
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      ScrollIntoView('error-display');
    }, 100);
  }

  private reassign() {
    this.ordersApi
      .reassignOrderTo({
        workorderReassignCommand: {
          workorderId: this.order.workorderId,
          targetWorkerName: this.newAssignee,
          reason: this.reason,
          reassignType:
            this.tab === 0 ? ReassignKind.NUMBER_0 : ReassignKind.NUMBER_1
        }
      })
      .then(this.successHandler, this.errorHandler);
  }

  private async cancelReassign() {
    this.popoverOpen = false;
    this.validationProblems = {};
    this.newAssignee = '';
    this.reason = '';
  }
}
